import React, { useEffect, useState } from 'react';
import { Link } from "react-router-dom";
import api from '../../../api';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import OwlCarousel from 'react-owl-carousel';
const ShopCategory = () => {

  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await api.get('/categories');
        setCategories(response.data.data);
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  // Owl Carousel Options
  const carouselOptions = {
    loop: true,
    margin: 20,
    nav: true,
    dots: false,
    autoplay: false,
    autoplayTimeout: 3000,
    autoplayHoverPause: true,
    responsive: {
      0: { items: 1 },
      600: { items: 2 },
      1000: { items: 4 }
    }
  };

  return (
    <section className="projects-section-six">
      <div className="container-fluid pb-0 pb-md-auto">
        <div className="text-center">
          <h3 className="sec-title">SHOP BY CATEGORY</h3>
        </div>

        <div className="owl-carousel-wrapper">
          <OwlCarousel className="projects-carousel-six owl-theme" {...carouselOptions}>
            {categories.map((category) => (
              <div className="project-block-six" key={category.id}>
                <div className="inner-box">
                  <figure className="image">
                    <Link to={`/category/${category.slug}`}>
                      <img src={category.cover_image} alt={category.name} className="img-fluid" />
                    </Link>
                  </figure>
                  <div className="content-box">
                    <Link className="theme-btn btn-style-three" to={`/category/${category.slug}`}style={{width:'100%',padding:0,margin:0}}>
                      {category.name} 
                    </Link>
                  </div>
                </div>
              </div>
            ))}
          </OwlCarousel>
        </div>
      </div>
    </section>
  );
};

export default ShopCategory;
